/**
 * Footer Component - Nintendo DS Style Controls
 */

import { useApp } from '../context/AppContext';

type Screen = 'home' | 'draft' | 'battle';

interface ButtonLabel {
  a: string;
  b: string;
  start: string;
}

const SCREEN_LABELS: Record<Screen, ButtonLabel> = {
  home:   { a: 'Valider', b: '---',    start: 'Jouer' },
  draft:  { a: 'Choisir', b: 'Reroll', start: '---' },
  battle: { a: 'Copier',  b: 'Retour', start: 'Lancer' },
};

export function Footer() {
  const { state } = useApp();
  const screen = (state.screen as Screen) in SCREEN_LABELS ? (state.screen as Screen) : 'home';
  const labels = SCREEN_LABELS[screen];

  return (
    <div
      className="w-full bg-gradient-to-b from-gray-700 to-gray-800 border-t-2 border-gray-900 py-4 px-6 flex items-center justify-between shadow-lg relative"
      style={{
        boxShadow: 'inset 0 2px 0 rgba(0, 0, 0, 0.5), 0 -4px 15px rgba(0, 0, 0, 0.5)',
        borderRadius: '12px 12px 0 0'
      }}
    >
      {/* DS Controls (Contextual) */}
      <div className="flex items-center gap-4 font-retro text-xs text-gray-300">
        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded-full bg-green-500 border-2 border-green-700 text-white font-bold text-sm flex items-center justify-center shadow-lg"
            style={{ boxShadow: '0 3px 8px rgba(34, 197, 94, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5)' }}
          >
            A
          </div>
          <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>{labels.a.toUpperCase()}</span>
        </div>

        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded-full bg-red-500 border-2 border-red-700 text-white font-bold text-sm flex items-center justify-center shadow-lg"
            style={{ boxShadow: '0 3px 8px rgba(239, 68, 68, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5)' }}
          >
            B
          </div>
          <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>{labels.b.toUpperCase()}</span>
        </div>

        <div className="flex items-center gap-2">
          <div
            className="px-2.5 py-1 rounded bg-gray-500 border-2 border-gray-700 text-white font-bold text-[10px] shadow-lg"
            style={{ boxShadow: '0 3px 8px rgba(107, 114, 128, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5)' }}
          >
            START
          </div>
          <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>{labels.start.toUpperCase()}</span>
        </div>

        <div className="flex items-center gap-2">
          <div
            className="px-2 py-1 rounded bg-gray-500 border-2 border-gray-700 text-white font-bold text-[10px] shadow-lg"
            style={{ boxShadow: '0 3px 8px rgba(107, 114, 128, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.5)' }}
          >
            SELECT
          </div>
          <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>OPTIONS</span>
        </div>
      </div>

      {/* Credit */}
      <div className="flex items-center gap-2 font-retro text-[10px] text-gray-400">
        <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>Made by</span>
        <a
          href="https://github.com/Tomi-Tom"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 transition-colors underline"
          style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}
        >
          Tomi-Tom
        </a>
      </div>
    </div>
  );
}

export default Footer;
